"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRecommendationHandset = void 0;
var _recommendationActions = require("../../store/recommendation/recommendationActions");
var _useQuestionsMetadata = require("../questionnaire/useQuestionsMetadata");
var _constants = require("../../utils/constants");
var _useAppDispatch = require("../useAppDispatch");
const getSelectedColorInTree = (selectedColor, colorVariants) => {
  var _selectedColor$value, _selectedColor$value$;
  const colorValue = selectedColor === null || selectedColor === void 0 ? void 0 : (_selectedColor$value = selectedColor.value) === null || _selectedColor$value === void 0 ? void 0 : (_selectedColor$value$ = _selectedColor$value.find(c => c.isDefault == true)) === null || _selectedColor$value$ === void 0 ? void 0 : _selectedColor$value$.value;
  const selectedColorInTree = colorVariants === null || colorVariants === void 0 ? void 0 : colorVariants.find(color => color.value.find(c => c.value == colorValue));
  return selectedColorInTree;
};
const transformColor = color => {
  var _color$value, _color$value$find;
  return {
    text: color === null || color === void 0 ? void 0 : (_color$value = color.value) === null || _color$value === void 0 ? void 0 : (_color$value$find = _color$value.find(c => c.isDefault == true)) === null || _color$value$find === void 0 ? void 0 : _color$value$find.value.split('|')[1],
    value: color === null || color === void 0 ? void 0 : color.variantId,
    color: Array.isArray(color === null || color === void 0 ? void 0 : color.value) ? color === null || color === void 0 ? void 0 : color.value[0].value.split('|')[0] : color === null || color === void 0 ? void 0 : color.value.split('|')[0]
  };
};
const transformMemory = memory => {
  var _memory$value, _memory$value2;
  return {
    text: (memory === null || memory === void 0 ? void 0 : (_memory$value = memory.value) === null || _memory$value === void 0 ? void 0 : _memory$value.value) + (memory === null || memory === void 0 ? void 0 : (_memory$value2 = memory.value) === null || _memory$value2 === void 0 ? void 0 : _memory$value2.unitOfMeasure),
    value: memory === null || memory === void 0 ? void 0 : memory.variantId
  };
};
const getRefurbishedCondition = handset => {
  var _handset$variants, _handset$variants2, _getProductCondition, _refurbishedVariant$p;
  const {
    flags
  } = (0, _useQuestionsMetadata.useQuestionsMetadata)({});
  const getProductCondition = (product, condition) => {
    var _product$characterist;
    const refurbishedCondition = (_product$characterist = product.characteristics) === null || _product$characterist === void 0 ? void 0 : _product$characterist.find(c => c.id === 'condition');
    return refurbishedCondition && refurbishedCondition.valueText === condition;
  };
  const refurbishedVariant = (_handset$variants = handset.variants) === null || _handset$variants === void 0 ? void 0 : _handset$variants.find(variant => getProductCondition(variant, 'Refurbished'));
  const newConditionVariant = (_handset$variants2 = handset.variants) === null || _handset$variants2 === void 0 ? void 0 : _handset$variants2.find(variant => getProductCondition(variant, 'New'));
  return {
    isRefurbishedHandset: (_getProductCondition = getProductCondition(handset, 'Refurbished')) !== null && _getProductCondition !== void 0 ? _getProductCondition : false,
    isRefurbishedAvailable: (flags === null || flags === void 0 ? void 0 : flags['refurbished-handset']) && !!refurbishedVariant,
    refurbishedVariant,
    newConditionVariant,
    refurbishedVariantPrice: refurbishedVariant === null || refurbishedVariant === void 0 ? void 0 : (_refurbishedVariant$p = refurbishedVariant.price) === null || _refurbishedVariant$p === void 0 ? void 0 : _refurbishedVariant$p.find(p => p.priceType = _constants.PRICE_TYPES.UP_FRONT)
  };
};
const getHandsetFilters = handset => {
  var _selectedColorInTree$, _memoryVariantsOption, _memoryVariantsOption2;
  const {
    filterTree,
    selectedVariant
  } = handset;
  const refurbishedCondition = getRefurbishedCondition(handset);
  const selectedColor = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.color;
  const selectedMemory = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.memory;
  const colorVariants = filterTree === null || filterTree === void 0 ? void 0 : filterTree.filter(variant => {
    return variant.variants.some(variant => {
      return !(variant !== null && variant !== void 0 && variant.refurbishedCondition) || (variant === null || variant === void 0 ? void 0 : variant.refurbishedCondition) === (refurbishedCondition !== null && refurbishedCondition !== void 0 && refurbishedCondition.isRefurbishedHandset ? 'Refurbished' : 'New');
    });
  });
  const selectedColorInTree = getSelectedColorInTree(selectedColor, colorVariants);
  const memoryVariants = selectedColorInTree === null || selectedColorInTree === void 0 ? void 0 : (_selectedColorInTree$ = selectedColorInTree.variants) === null || _selectedColorInTree$ === void 0 ? void 0 : _selectedColorInTree$.filter(variant => {
    var _variant$value;
    return (variant === null || variant === void 0 ? void 0 : (_variant$value = variant.value) === null || _variant$value === void 0 ? void 0 : _variant$value.value) && (!(variant !== null && variant !== void 0 && variant.refurbishedCondition) || (variant === null || variant === void 0 ? void 0 : variant.refurbishedCondition) === (refurbishedCondition !== null && refurbishedCondition !== void 0 && refurbishedCondition.isRefurbishedHandset ? 'Refurbished' : 'New'));
  });
  const selectedMemoryInTree = memoryVariants === null || memoryVariants === void 0 ? void 0 : memoryVariants.find(memory => memory.variantId === selectedMemory.variantId);
  let memoryVariantsOptions = memoryVariants === null || memoryVariants === void 0 ? void 0 : memoryVariants.map(transformMemory);
  const memoryVariantsValues = (_memoryVariantsOption = memoryVariantsOptions) === null || _memoryVariantsOption === void 0 ? void 0 : _memoryVariantsOption.map(m => m.text);
  memoryVariantsOptions = (_memoryVariantsOption2 = memoryVariantsOptions) === null || _memoryVariantsOption2 === void 0 ? void 0 : _memoryVariantsOption2.map(m => {
    var _handset$variants$fin, _handset$variants$fin2, _handset$variants$fin3, _handset$variants$fin4;
    const variantHint = (_handset$variants$fin = handset.variants.find(v => v.variantId === m.value)) === null || _handset$variants$fin === void 0 ? void 0 : (_handset$variants$fin2 = _handset$variants$fin.productDescription) === null || _handset$variants$fin2 === void 0 ? void 0 : (_handset$variants$fin3 = _handset$variants$fin2.replace(handset.productName, '')) === null || _handset$variants$fin3 === void 0 ? void 0 : (_handset$variants$fin4 = _handset$variants$fin3.replace(m.text, '')) === null || _handset$variants$fin4 === void 0 ? void 0 : _handset$variants$fin4.trim();
    if (memoryVariantsValues.filter(v => v === m.text).length > 1) m.text = `${m.text} -${variantHint}`;
    return m;
  });
  return {
    colorVariants: colorVariants === null || colorVariants === void 0 ? void 0 : colorVariants.map(transformColor),
    memoryVariants: memoryVariantsOptions,
    selectedColor: transformColor(selectedColorInTree),
    selectedMemory: transformMemory(selectedMemoryInTree),
    refurbishedCondition: refurbishedCondition
  };
};
const useRecommendationHandset = handset => {
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const filters = getHandsetFilters(handset);
  const onHandsetSelect = productId => {
    dispatch((0, _recommendationActions.updateSelectedHandset)(productId));
  };
  const onVariantSelect = (productId, variantId) => {
    dispatch((0, _recommendationActions.updateSelectedVariant)(productId, variantId));
  };
  return {
    filters,
    onHandsetSelect,
    onVariantSelect
  };
};
exports.useRecommendationHandset = useRecommendationHandset;